import React from 'react';
import './ImagePreview.css';

/**
 * Component to preview selected images before sending
 *
 * @param {Object[]} images - Array of File objects
 * @param {Function} onRemove - Callback when image is removed: (index) => void
 */
const ImagePreview = ({ images, onRemove }) => {
  if (!images || images.length === 0) {
    return null;
  }

  return (
    <div className="image-preview-container">
      {images.map((file, index) => (
        <div key={index} className="image-preview-item">
          <img
            src={URL.createObjectURL(file)}
            alt={`Preview ${index + 1}`}
            className="preview-thumbnail"
          />
          <button
            type="button"
            className="remove-image-btn"
            onClick={() => onRemove(index)}
            aria-label={`Remove ${file.name}`}
          >
            ×
          </button>
          <div className="image-filename">{file.name}</div>
        </div>
      ))}
    </div>
  );
};

export default ImagePreview;
